import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationsStateSelector } from "../recommendationsStateSelector";

export const recommendationAppliedAccountsSelector = createDraftSafeSelector(
  [recommendationsStateSelector],
  (state) => {
    return state.filters.accounts;
  },
);
